import { Component, EventEmitter, Input, Output, signal, ViewChild, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, ReactiveFormsModule } from '@angular/forms';
import { MAT_LUXON_DATE_FORMATS, provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatDateFormats, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerInput, MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { defaultDateFormat } from '@config';
import { IconComponent } from '@libs/components/icons';
import { DateInputModel } from '@libs/form/models';
import { DateTime } from 'luxon';
import { ErrorDirective, InputAttributesDirective, InputValidatorsDirective } from '../../../directives';
import { InputBaseComponent } from '../../../models';
import { FormInputDescriptionComponent } from '../../description';
import { InputProviderFactory } from '../ng-input-provider';

export const dateFormats: MatDateFormats = {
  ...MAT_LUXON_DATE_FORMATS,
  display: {
    ...MAT_LUXON_DATE_FORMATS.display,
    dateInput: defaultDateFormat, // dd.MM.yyyy with de-DE
  },
};

@Component({
  selector: 'ui-form-date',
  templateUrl: './date.component.html',
  providers: [
    ...InputProviderFactory.getProviders(DateComponent),
    provideLuxonDateAdapter(dateFormats),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ErrorDirective,
    InputAttributesDirective,
    InputValidatorsDirective,
    IconComponent,
    MatButtonModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    FormInputDescriptionComponent,
  ],
})
export class DateComponent extends InputBaseComponent {
  @Input() public data!: DateInputModel;
  @Output() public datePickerToggleEvent: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild(MatDatepickerInput, { static: true })
  public valueAccessor!: ControlValueAccessor;

  public defaultFilter: WritableSignal<(date: (DateTime | null)) => boolean> = signal(() => true);

  public onDatePickerToggleClicked(): void {
    this.datePickerToggleEvent.emit();
  }
}
